import { createFileRoute } from '@tanstack/react-router'
import { YouTubeEmbed } from '~/components/ui/YouTubeEmbed'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { Container } from '~/components/ui/Container'
import { PageTitle } from '~/components/ui/PageTitle'
import { PageHero } from '~/components/ui/PageHero'

export const Route = createFileRoute('/thank-you')({
  headers: () => cacheHeaders.content,
  head: () =>
    pageMeta({
      title: 'Thank You',
      description: 'Thank you for your support of Direct Action Everywhere.',
      ogDescription: 'Thank you for your support.',
      noindex: true,
    }),
  component: ThankYou,
})

function ThankYou() {
  return (
    <PageHero as="div" bottom="page">
      <Container width="narrow">
        <PageTitle className="mb-5">Thank you for your support</PageTitle>
        <p className="mb-0 text-lg leading-[26px]">
          If you have any questions about your donation, please contact us at{' '}
          <a
            href="mailto:fundraising@directactioneverywhere.com"
            className="break-words text-accent underline"
          >
            fundraising@directactioneverywhere.com
          </a>
          .
        </p>
        <YouTubeEmbed
          id="RNVULSYMfH8"
          query="rel=0&controls=1"
          title="A big thank you from all us!"
          className="mt-10"
        />
      </Container>
    </PageHero>
  )
}
